// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2242":"da4f21b75a329fc3","6305":"ffd983f68a1b5887","7055":"edc92ec24d6493a4","9922":"8cf28f18265b94d1"}[chunkId] + ".css";
};